module.exports = "<div *ngIf=\"enabled\" class=\"loading\">Loading&#8230;</div>"


//////////////////
// WEBPACK FOOTER
// /home/jacobo/proyectos/venta-extranet/src/app/shared/components/loading/loading.component.html
// module id = ../../../../../src/app/shared/components/loading/loading.component.html
// module chunks = main